/**
 * Calculate the time zone offset
 */
export const getTimezoneOffset = (loc) => {
    let destinationOffset = new Intl.DateTimeFormat('en-US', { timeZone: loc, timeZoneName: 'longOffset' })
        .formatToParts(new Date())
        .filter((e) => e.type === 'timeZoneName')[0]
        .value.replace('GMT', '');
    let isNegativeDestination = destinationOffset.includes('-');
    let destinationTimeParts = destinationOffset.replace('-', '').split(':');
    let destinationNumericOffset = Number(destinationTimeParts[0]) * 60 + Number(destinationTimeParts[1] || 0);
    destinationNumericOffset = isNegativeDestination ? -destinationNumericOffset : destinationNumericOffset;
    let userOffset = new Intl.DateTimeFormat('en-US', { timeZoneName: 'longOffset' })
        .formatToParts()
        .filter((e) => e.type === 'timeZoneName')[0]
        .value.replace('GMT', '');
    let isNegativeUser = userOffset.includes('-');
    let userTimeParts = userOffset.replace('-', '').split(':');
    let userNumericOffset = Number(userTimeParts[0]) * 60 + Number(userTimeParts[1] || 0);
    userNumericOffset = isNegativeUser ? -userNumericOffset : userNumericOffset;
    let totalOffset = destinationNumericOffset - userNumericOffset;
    return totalOffset;
};
export const printToUserTimezone = (ISOdate, format = 'full', style = 'full', forceISO = false) => {
    var _a;
    // Time zone calculation
    const timezones = (_a = window.timezones) === null || _a === void 0 ? void 0 : _a.split('|');
    const userTz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    let actualTimezone = timezones[0];
    if (timezones.includes(userTz)) {
        actualTimezone = userTz;
    }
    const tzDate = new Date(ISOdate);
    tzDate.setMinutes(tzDate.getMinutes() + getTimezoneOffset(actualTimezone));
    const formatter = {};
    if (format == 'date' || format == 'full') {
        formatter.dateStyle = style;
    }
    if (format == 'time' || format == 'full') {
        formatter.timeStyle = style;
    }
    const finalDate = new Intl.DateTimeFormat(forceISO ? 'sv-SE' : window.language.toLowerCase() + '-' + window.country.toUpperCase(), formatter).format(tzDate);
    return finalDate;
};
export const editISODate = (ISODate, edits) => {
    let date = new Date(ISODate);
    if (edits.hours) {
        date.setHours(date.getHours() + edits.hours);
    }
    if (edits.minutes) {
        date.setMinutes(date.getMinutes() + edits.minutes);
    }
    if (edits.seconds) {
        date.setSeconds(date.getSeconds() + edits.seconds);
    }
    if (edits.milliseconds) {
        date.setMilliseconds(date.getMilliseconds() + edits.milliseconds);
    }
    return date.toISOString();
};
